import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=191da384&scoped=true&"
import script from "./Consultations.vue?vue&type=script&lang=ts&"
export * from "./Consultations.vue?vue&type=script&lang=ts&"
import style0 from "./Consultations.vue?vue&type=style&index=0&id=191da384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191da384",
  null
  
)

export default component.exports